import React from 'react';

export default function BigIdea() {
  return (
    <section id="about" className="section-padding bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto relative z-10 px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="mb-12">
              <span className="text-brand-red font-bold uppercase tracking-widest text-sm mb-4 block">ที่มาของหลักสูตรนี้</span>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-zinc-900 mb-8 leading-tight">
                19 ปี 3,000 ดวง <br /> 
                <span className="text-zinc-500 font-medium text-4xl mt-2 block">กับสิ่งที่ตำราไม่เคยสอน</span>
              </h2>
            </div>
            
            <div className="prose prose-lg max-w-none text-zinc-700 space-y-8 leading-relaxed font-medium">
              <p>
                ตลอด 19 ปีที่ผ่านมา อ.รวิ อัญญากาญจน์ ได้ดูดวงให้คนมากกว่า 3,000 ดวง โดยกว่า 70–80% เป็นนักลงทุนและนักธุรกิจ ตั้งแต่พนักงานออฟฟิศทั่วไป ไปจนถึงนักธุรกิจระดับหมื่นล้าน หลายท่านคือคนที่ประสบความสำเร็จทางการเงินในรูปแบบที่แตกต่างกันไป
              </p>

              <blockquote className="border-l-8 border-brand-red pl-8 py-6 my-12 bg-zinc-50 text-2xl text-zinc-900 font-bold italic">
                "แม้ปาจื้อจะมีตำราอ้างอิงและหลักการที่เป็นสากล แต่สิ่งที่ตำราให้ไม่ได้ คือ รูปแบบ (pattern) ที่ซ้ำกันจริงๆ ระหว่าง 'ดวงที่มั่งคั่ง' กับ 'จังหวะการลงทุนที่แม่นยำ'"
              </blockquote>

              <p>
                นี่คือเหตุผลที่หลักสูตรนี้ไม่ได้สอนแค่ "ทฤษฎีปาจื้อการเงิน" แต่สอนแบบเทียบให้เห็นภาพ ระหว่างแนวทางดั้งเดิม และแนวทางประยุกต์สำหรับยุคการลงทุนสมัยใหม่
              </p>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="relative">
              <div className="aspect-[4/5] bg-zinc-100 border border-zinc-200 overflow-hidden shadow-2xl">
                <img 
                  src="https://media-manager-c.questera.ai/greta-media/471e332637c745cac6e5f952a1669a461aea7ff8853c3b4ee7dd2b5f799ce1f00d91c0ccf6cd346bf4393cbd10a6b0de/images/aW1hZ2UvcG5n/4d6de8fe773885a3d0cb4b2dd8e1ee76.png" 
                  alt="Luo Pan Compass on Currency" 
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-brand-red text-white p-8 hidden md:block shadow-xl">
                <div className="text-4xl font-black mb-1">19+</div>
                <div className="text-[10px] font-bold uppercase tracking-widest opacity-80">Years of Experience</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}